import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PanelImage from '../../assets/svg/panelImage.svg';
import ImageMobile from '../../assets/svg/panelImageMobile.svg';
import { gtmAttributesUpdateTokenErrorPage } from '../../utils/gtmVariables';
import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';

import Panel from '../../components/Panel';
import Typography from '../../components/Typography';

interface LocationState {
  to: string;
}

const IntegrationError = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { to = '/' } = (location.state as LocationState) || {};
  const gtmEventsTracker = useGTMEventsTracker();
  gtmEventsTracker(gtmAttributesUpdateTokenErrorPage);

  return (
    <Panel
      panelType="confirmation"
      title="Integradora habilitada"
      description={
        <Typography>
          A integradora de produtos da sua loja foi habilitada em nossa plataforma. Você{' '}
          <strong>receberá o token de ativação por email.</strong>
        </Typography>
      }
      image={PanelImage}
      imageMobile={ImageMobile}
      buttonText="Continuar"
      buttonId="mp__integration-error_btn"
      onClick={() => navigate(to)}
    />
  );
};

export default IntegrationError;
